// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { serialize_SearchFiltersForm } from "@newgenerated/shared/serializerDeserializer/SearchFiltersForm";
import { deserialize_FullSearchResults } from "@newgenerated/shared/serializerDeserializer/FullSearchResults";

export async function search(props: { body: schema.SearchFiltersForm }): Promise<ApiResult<schema.FullSearchResults>> {
  const path = "/gaapi/search/fullSearch";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return serialize_SearchFiltersForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.FullSearchResults> => {
    return deserialize_FullSearchResults(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
